"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.FooterEntity = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../../types");
var field_groups_1 = require("../../field-groups");
var fields_1 = require("../../fields");
var slices_1 = require("../../slices");
var entity_factory_1 = require("../entity-factory");
var slices_2 = require("./slices");
exports.FooterEntity = entity_factory_1.entityFactory(types_1.DocumentType.FOOTER, function (prismicDoc, normalizedEntity, logger) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return utils_1.compact(__assign(__assign({}, normalizedEntity), { uid: types_1.DocumentType.FOOTER, type: types_1.DocumentType.FOOTER, logo: logger.required(fields_1.toImage((_a = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _a === void 0 ? void 0 : _a.images_logo, logger)), image: logger.required(fields_1.toImage((_b = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _b === void 0 ? void 0 : _b.images_image, logger)), imageLink: fields_1.toLink((_c = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _c === void 0 ? void 0 : _c.images_image_link, logger), menu: slices_1.processSlices({
            footerLink: slices_2.footerLink,
            rgpdLink: slices_2.rgpdLink
        }, (_d = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _d === void 0 ? void 0 : _d.menu_links, logger), contents: (_f = (_e = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _e === void 0 ? void 0 : _e.contents_contents) === null || _f === void 0 ? void 0 : _f.map(function (dataContent) {
            var content = utils_1.unprefix('section', dataContent);
            return {
                title: logger.required(fields_1.toText(content === null || content === void 0 ? void 0 : content.title)),
                subtitle: fields_1.toText(content === null || content === void 0 ? void 0 : content.subtitle),
                cta: field_groups_1.toCta(content, logger)
            };
        }), socialNetworks: {
            title: (_g = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _g === void 0 ? void 0 : _g.socialnetworks_title,
            list: (_j = (_h = prismicDoc === null || prismicDoc === void 0 ? void 0 : prismicDoc.data) === null || _h === void 0 ? void 0 : _h.socialnetworks_list) === null || _j === void 0 ? void 0 : _j.map(function (rs) {
                return {
                    type: logger.required(types_1.SocialLinkTypes[rs.socialNetworkType.toUpperCase()]),
                    link: logger.required(fields_1.toWebLink(rs.link, logger))
                };
            })
        } }));
});
//# sourceMappingURL=footer.js.map